import "./svg/arrow-8.svg"

export default {
    name: "arrow-8",
    viewBox: "100 100",
}
